import { useLocation } from "react-router-dom";
import type { FC } from "react";
import { useEffect } from "react";

interface Props {
  readonly title: string;
}

const PageTitle: FC<Props> = ({ title }) => {
  const location = useLocation();

  useEffect(() => {
    document.title = `przezmorze.pl - ${title}`;
  }, [location, title]);

  return null;
};

export default PageTitle;
